<template>
  <section class="section">
    <div class="container is-fluid">
      <h1 class="title">
        {{ $translate('orders') | capitalize }}
      </h1>
      <div class="level first-level">
        <div class="level-left">
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button slot="trigger" :disabled="tableOptions.loading" type="button is-primary" icon-right="printer" />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.loading || tableOptions.checkedRows.length == 0"
                @click="openPrintModal()"
              >
                {{ $translate('print') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                :disabled="tableOptions.loading"
                type="button is-primary"
                icon-right="content-copy"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length != 1 || isClosed() != 1"
                @click="openCopyOrder(tableOptions.checkedRows[0])"
              >
                {{ $translate('copy_order') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                class="button is-primary"
                :disabled="tableOptions.loading"
                icon-right="attachment"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="
                  tableOptions.checkedRows.length == 0 ||
                    isJSONViewableCustomer ||
                    (userInfo.type == 'C' && userInfo.level == '1')
                "
                @click="
                  if (
                    tableOptions.checkedRows.length != 0 &&
                    !isJSONViewableCustomer &&
                    (userInfo.type != 'C' || userInfo.level != '1')
                  ) {
                    exportJsonArray()
                  }
                "
              >
                {{ $translate('json') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="
                  tableOptions.loading ||
                    tableOptions.checkedRows.length == 0 ||
                    isJSONViewableCustomer ||
                    (userInfo.type == 'C' && userInfo.level == '1')
                "
                @click="
                  if (
                    !tableOptions.loading &&
                    tableOptions.checkedRows.length != 0 &&
                    !isJSONViewableCustomer &&
                    (userInfo.type != 'C' || userInfo.level != '1')
                  ) {
                    sendJsonArrayToMercurio()
                  }
                "
              >
                {{ $translate('send_to_mercurio') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length == 0 || (userInfo.type == 'C' && userInfo.level == '1')"
                @click="
                  if (tableOptions.checkedRows.length != 0 && (userInfo.type != 'C' || userInfo.level != '1')) {
                    //getCSV(tableOptions.checkedRows);
                    printCSV(tableOptions.checkedRows)
                  }
                "
              >
                {{ $translate('csv_download') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length == 0"
                @click="
                  if (tableOptions.checkedRows.length != 0) {
                    exportPdfTable()
                  }
                "
              >
                {{ $translate('pdf_download') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                type="button is-primary"
                icon-right="pencil-outline"
                :disabled="tableOptions.loading"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="isTrackingNumberDisabled()"
                @click="
                  if (!isTrackingNumberDisabled()) {
                    trackcodechangemodal()
                  }
                "
              >
                {{ $translate('track_numbe_change') | capitalize }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                type="button is-primary"
                :disabled="tableOptions.loading"
                icon-right="send-outline"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="!hasSameStatus()"
                @click="
                  if (hasSameStatus()) {
                    changeStatus('invord')
                  }
                "
              >
                {{ $translate('save_envo') }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="!hasSameStatus() || userInfo.level == 1"
                @click="
                  if (hasSameStatus() || userInfo.level == 1) {
                    changeStatus('sendord')
                  }
                "
              >
                {{ $translate('save_sended') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <b-button
                slot="trigger"
                type="is-primary"
                class="button is-primary"
                :disabled="tableOptions.loading"
                icon-right="format-list-checkbox"
              />
              <b-dropdown-item
                class="pointercursor linktype"
                @click="
                  isSwitched = 0
                  searchData()
                "
              >
                {{ $translate('actives') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                @click="
                  isSwitched = 1
                  searchData()
                "
              >
                {{ $translate('closeds') | capitalize }}
              </b-dropdown-item>
              <b-dropdown-item
                class="pointercursor linktype"
                @click="
                  isSwitched = 2
                  searchData()
                "
              >
                {{ $translate('cestino') }}
              </b-dropdown-item>
            </b-dropdown>
          </div>
          <div class="level-item">
            <b-field :label="$translate('startdate') | capitalize" label-position="on-border">
              <b-datepicker
                v-model="startDate"
                :disabled="tableOptions.loading"
                size="is-small"
                :placeholder="$translate('startdate')"
                icon="calendar-today"
                :date-formatter="date => new Intl.DateTimeFormat('it-IT').format(date)"
                :date-parser="
                  date => {
                    let dateArray = date.split(/[.//-]/)
                    return new Date(`${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`)
                  }
                "
                editable
                locale="it-IT"
                @input="searchData()"
              >
                <button
                  class="button is-danger"
                  @click="
                    startDate = null
                    searchData()
                  "
                >
                  <b-icon icon="close" />
                  <span>{{ $translate('delete') }}</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
          <div class="level-item">
            <b-field :label="$translate('enddate') | capitalize" label-position="on-border">
              <b-datepicker
                v-model="enddate"
                :disabled="tableOptions.loading"
                size="is-small"
                :placeholder="$translate('enddate')"
                icon="calendar-today"
                :date-formatter="date => new Intl.DateTimeFormat('it-IT').format(date)"
                :date-parser="
                  date => {
                    let dateArray = date.split(/[.//-]/)
                    return new Date(`${dateArray[1]}-${dateArray[0]}-${dateArray[2]}`)
                  }
                "
                editable
                locale="it-IT"
                @input="searchData()"
              >
                <button
                  class="button is-danger"
                  @click="
                    enddate = null
                    searchData()
                  "
                >
                  <b-icon icon="close" />
                  <span>{{ $translate('delete') }}</span>
                </button>
              </b-datepicker>
            </b-field>
          </div>
        </div>
        <div class="level-right">
          <b-input
            v-model="queryString"
            :placeholder="$translate('search').concat('...') | capitalize"
            type="search"
            icon="magnify"
            :disabled="tableOptions.loading"
            @keyup.native.enter="searchData"
          />
        </div>
      </div>
      <div class="level second-level">
        <div class="level-left">
          <div class="level-item">
            <p class="is-size-5 has-text-primary">
              {{ $translate('filter') | capitalize }}
            </p>
          </div>
          <div class="level-item">
            <filter-select
              v-model="orderTypeFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="orderTypeMainFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="deliverySelectedFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="statusOrderFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
          <div class="level-item">
            <filter-select
              v-model="moduleFilterInfo"
              :disabledbool.sync="tableOptions.loading"
              @change="searchData()"
            />
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <p class="is-size-5 has-text-primary">
              {{ $translate('changeStatus') | capitalize }}
            </p>
          </div>
          <div class="level-item">
            <b-field :label="$translate('status') | capitalize" label-position="on-border">
              <b-select v-model="statusSelected" size="is-small">
                <option v-for="status in availableStatus" :key="status" :value="status">
                  {{ $translate(status) }}
                </option>
              </b-select>
            </b-field>
          </div>
          <div class="level-item">
            <b-button
              :disabled="isMassiveChangeDisabled()"
              class="is-primary"
              @click="changeStatus() /*groupChangeStatus()*/"
            >
              {{ $translate('confirm') }}
            </b-button>
          </div>
        </div>
      </div>
      <!--<div class="level">
        <div class="level-left">
          <div class="level-item">
            <div class="level-item">
              <b-button
                type="is-primary"
                icon-right="barcode"
                :disabled="isTrackingNumberDisabled()"
                @click="trackcodechangemodal()"
              ></b-button>
            </div>
            <div class="level-item">
              <b-button
                type="is-primary"
                icon-right="table-large"
                :disabled="tableOptions.checkedRows.length == 0"
                @click="getTable()"
              ></b-button>
            </div>
            <b-button
              type="is-primary"
              icon-right="file-pdf"
              :disabled="tableOptions.checkedRows.length == 0"
              @click="exportPdfTable()"
            ></b-button>
          </div>
         <div class="level-item">
            <b-button
              type="is-primary"
              icon-right="printer"
              @click="openPrintModal()"
              :disabled="tableOptions.checkedRows.length == 0"
            ></b-button>
          </div>
          <div class="level-item">
            <b-button
              type="is-primary"
              icon-right="content-copy"
              @click="
                $router.push({
                  name: 'copyOrder',
                  params: { orderIdToCopy: tableOptions.checkedRows[0].id }
                })
              "
              :disabled="tableOptions.checkedRows.length != 1"
            ></b-button>
          </div>
          <div class="level-item">
            <b-dropdown aria-role="list">
              <button
                type="button"
                class="button is-primary"
                :disabled="tableOptions.loading"
                slot="trigger"
              >
                <b-icon icon="attachment"></b-icon>
              </button>
              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="
                  tableOptions.checkedRows.length == 0 ||
                    isJSONViewableCustomer ||
                    (userInfo.type == 'C' && userInfo.level == '1')
                "
                @click="
                  if (
                    tableOptions.checkedRows.length != 0 &&
                    !isJSONViewableCustomer &&
                    (userInfo.type != 'C' || userInfo.level != '1')
                  ) {
                    exportJsonArray();
                  }
                "
              >
                <b-icon icon="code-braces" size="is-small"></b-icon>
                &nbsp;
                {{ $translate("json") | capitalize }}
              </b-dropdown-item>

              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="
                  tableOptions.checkedRows.length == 0 ||
                    (userInfo.type == 'C' && userInfo.level == '1')
                "
                @click="
                  if (
                    tableOptions.checkedRows.length != 0 &&
                    (userInfo.type != 'C' || userInfo.level != '1')
                  ) {
                    getCSV(tableOptions.checkedRows);
                  }
                "
              >
                <b-icon icon="table-large" size="is-small"></b-icon>
                &nbsp;
                {{ $translate("csv_download") | capitalize }}
              </b-dropdown-item>

              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="tableOptions.checkedRows.length == 0"
                @click="
                  if (tableOptions.checkedRows.length != 0) {
                    exportPdfTable();
                  }
                "
              >
                <b-icon icon="file-pdf" size="is-small"></b-icon>
                &nbsp;
                {{ $translate("pdf_download") | capitalize }}
              </b-dropdown-item>

              <b-dropdown-item class="pointercursor">
                <b-button
                  class="is-text is-button-link"
                  :disabled="
                    tableOptions.checkedRows.length == 0 ||
                      isJSONViewableCustomer ||
                      (userInfo.type == 'C' && this.userInfo.level == '1')
                  "
                  icon-left="code-braces"
                  @click="exportJsonArray()"
                >
                  {{ $translate("json") | capitalize }}
                </b-button>
              </b-dropdown-item>
              <b-dropdown-item class="pointercursor">
                <b-button
                  class="is-text is-button-link"
                  :disabled="tableOptions.checkedRows.length == 0"
                  @click="getAttachment()"
                  icon-left="download"
                >
                  {{ $translate("download_attach") | capitalize }}
                </b-button>
              </b-dropdown-item>

              <b-dropdown-item class="pointercursor">
                <b-button
                  class="is-text is-button-link"
                  :disabled="
                    tableOptions.checkedRows.length == 0 ||
                      (userInfo.type == 'C' && this.userInfo.level == '1')
                  "
                  @click="getCSV(tableOptions.checkedRows)"
                  icon-left="table-large"
                >
                  {{ $translate("csv_download") | capitalize }}
                </b-button>
              </b-dropdown-item>

              <b-dropdown-item class="pointercursor">
                <b-button
                  class="is-text is-button-link"
                  :disabled="tableOptions.checkedRows.length == 0"
                  @click="exportPdfTable()"
                  icon-left="file-pdf"
                >
                  {{ $translate("pdf_download") | capitalize }}
                </b-button>
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="level-item">
            <b-dropdown aria-role="list">
              <button
                type="button"
                class="button is-primary"
                :disabled="tableOptions.loading"
                slot="trigger"
              >
                <b-icon icon="pencil-outline"></b-icon>
              </button>

              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="isTrackingNumberDisabled()"
                @click="
                  if (!isTrackingNumberDisabled()) {
                    trackcodechangemodal();
                  }
                "
              >
                <b-icon icon="barcode" size="is-small"></b-icon>
                &nbsp;
                {{ $translate("track_numbe_change") | capitalize }}
              </b-dropdown-item>

              <b-dropdown-item class="pointercursor">
                <b-button
                  class="is-text is-button-link"
                  :disabled="tableOptions.checkedRows.length == 0"
                  @click="massivemercurioidchangemodal()"
                  icon-left="key"
                >
                  {{ $translate("edit_mercury_id") }}
                </b-button>
              </b-dropdown-item>
            </b-dropdown>
          </div>

          <div class="level-item">
            <b-dropdown aria-role="list">
              <button
                type="button"
                class="button is-primary"
                :disabled="tableOptions.loading"
                slot="trigger"
              >
                <b-icon icon="send"></b-icon>
              </button>

              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="!hasSameStatus()"
                @click="
                  if (hasSameStatus()) {
                    changeStatus('invord');
                  }
                "
                >{{ $translate("save_envo") }}</b-dropdown-item
              >

              <b-dropdown-item
                class="pointercursor linktype"
                :disabled="!hasSameStatus() || userInfo.level == 1"
                @click="
                  if (hasSameStatus() || userInfo.level == 1) {
                    changeStatus('sendord');
                  }
                "
                >{{ $translate("save_sended") }}</b-dropdown-item
              >
            </b-dropdown>
          </div>

          <div class="level-item"></div>
          <div class="level-item">
            <b-switch v-model="isSwitched" @input="searchData()">{{
              $translate("cestino")
            }}</b-switch>
          </div>
        </div>
        <div class="level-right"></div>
      </div>-->
      <b-table
        :sticky-header="true"
        :data="tableData"
        :narrowed="true"
        :checked-rows.sync="tableOptions.checkedRows"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        :backend-sorting="true"
        checkable
        detailed
        :default-sort="[field, order]"
        :row-class="(row, index) => evaluateRowClass(row)"
        :is-row-checkable="row => !row.claim"
        hoverable
        @sort="sortPressed"
        @check="multipleSelectionIconManage"
      >
        <!--<b-table
        :row-class="(row, index) => row.claim && 'is-claim'"
        :data="filteredData"
        :paginated="tableOptions.isPaginated"
        :narrowed="true"
        :per-page="tableOptions.perPage"
        :current-page.sync="tableOptions.currentPage"
        :checked-rows.sync="tableOptions.checkedRows"
        :pagination-simple="tableOptions.isPaginationSimple"
        :sort-icon="tableOptions.sortIcon"
        :sort-icon-size="tableOptions.sortIconSize"
        :loading="tableOptions.loading"
        aria-next-label="Next page"
        aria-previous-label="Previous page"
        aria-page-label="Page"
        aria-current-label="Current page"
        checkable
        detailed
        @check="multipleSelectionIconManage"
        >-->
        <template slot-scope="props">
          <b-table-column field="patient.id" :label="$translate('patient') | capitalize">
            <a
              v-if="props.row.patient"
              @click="
                $router.push({
                  name: 'patients',
                  params: { patientId: props.row.patientId },
                })
              "
            >
              {{
                `${props.row.patient.name} ${props.row.patient.surname}
              ${props.row.patient.alias}`
              }}
            </a>
            <template v-else />
          </b-table-column>
          <b-table-column field="primaryCode" :label="$translate('primaryCode') | capitalize">
            <template v-if="!props.row.claim">
              {{ props.row.primaryCode }}
            </template>
          </b-table-column>
          <b-table-column field="orderType" :label="$translate('orderType') | capitalize" sortable>
            {{ `${$translate(props.row.orderType)}` }}
          </b-table-column>
          <b-table-column field="orderTypeMain" :label="$translate('orderTypeMain') | capitalize" sortable>
            {{ `${$translate(props.row.orderTypeMain)}` }}
          </b-table-column>
          <b-table-column field="deliverySelected" :label="$translate('deliverySelected') | capitalize" sortable>
            {{ `${$translate(props.row.deliverySelected)}` }}
          </b-table-column>
          <b-table-column field="id_mercury" :label="$translate('id_mercury') | capitalize">
            {{ props.row.id_mercury }}
          </b-table-column>
          <b-table-column field="send_date" :label="$translate('send_date') | capitalize" :sortable="allShops">
            <template
              v-if="props.row.send_date && new Date(props.row.send_date).toLocaleDateString() != 'Invalid Date'"
            >
              {{ new Date(props.row.send_date).toLocaleDateString() }}
            </template>
            <template v-else>
              -
            </template>
          </b-table-column>
          <b-table-column field="module" :label="$translate('module') | capitalize" sortable>
            <b-tag
              v-if="evaluateRowClass(props.row) !== 'is-claim'"
              class="module-tag"
              :type="
                props.row.module
                  ? $moduleConfiguration[props.row.module].tagColor
                  : $moduleConfiguration['tailored'].tagColor
              "
              >{{ $translate(props.row.module ? props.row.module : 'tailored') }}</b-tag
            >
          </b-table-column>
          <b-table-column field="statusOrder" :label="$translate('status') | capitalize" sortable>
            {{ $translate(props.row.statusOrder) ? $translate(props.row.statusOrder) : $translate(props.row.status) }}
          </b-table-column>
          <b-table-column :label="$translate('action') | capitalize">
            <template v-if="props.row.claim">
              <b-dropdown aria-role="list" position="is-bottom-left">
                <b-icon slot="trigger" class="has-text-primary" icon="menu-down" />
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="!amIClaimSender(props.row.AdminClaim) || props.row.status != 'saved'"
                  @click="
                    $router.push({
                      name: 'editClaim',
                      params: {
                        orderid: props.row.orderid,
                        id: props.row.id,
                      },
                    })
                  "
                >
                  {{ $translate('edit') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="
                    amIClaimSender(props.row.AdminClaim) ||
                      (props.row.status != 'sent' && props.row.status != 'responseSaved')
                  "
                  @click="
                    $router.push({
                      name: 'newResponsetoClaim',
                      params: {
                        claimid: props.row.id,
                        orderid: props.row.orderid,
                      },
                    })
                  "
                >
                  {{ $translate('response_claim') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="props.row.status == 'saved'"
                  @click="
                    $router.push({
                      name: 'Claim',
                      params: {
                        orderid: props.row.orderid,
                        id: props.row.id,
                      },
                    })
                  "
                >
                  {{ $translate('view_claim') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="!isClaimDeletable(props.row)"
                  @click="deleteOccurenceClaim(props.row.orderid, props.row.id)"
                >
                  {{ $translate('delete') | capitalize }}
                </b-dropdown-item>
              </b-dropdown>
              <!--<template v-if="!props.row.confirmed">
                  <b-dropdown-item
                    class="pointercursor"
                    aria-role="listitem"
                    :disabled="isEditClaimDoable(props.row.AdminClaim) == false"
                    @click="
                      $router.push({
                        name: 'editClaim',
                        params: { orderid: props.row.orderid, id: props.row.id }
                      })
                    "
                  >
                    <template v-if="!props.row.answer">{{
                      $translate("edit") | capitalize
                    }}</template>
                    <template v-else>{{
                      $translate("edit_claim_answered") | capitalize
                    }}</template>
                  </b-dropdown-item>

                  <b-dropdown-item
                    class="pointercursor"
                    aria-role="listitem"
                    :disabled="
                      isResponsetoaClaimDoable(props.row.AdminClaim) == false
                    "
                    @click="
                      $router.push({
                        name: 'newResponsetoClaim',
                        params: {
                          claimid: props.row.id,
                          orderid: props.row.orderid
                        }
                      })
                    "
                  >
                    <template v-if="!props.row.answer">{{
                      $translate("response_claim") | capitalize
                    }}</template>
                    <template v-else>{{
                      $translate("edit_response_claim") | capitalize
                    }}</template>
                  </b-dropdown-item>
                </template>
                <template v-else>
                  <b-dropdown-item
                    class="pointercursor"
                    aria-role="listitem"
                    @click="
                      $router.push({
                        name: 'Claim',
                        params: { orderid: props.row.orderid, id: props.row.id }
                      })
                    "
                    >{{ $translate("view_claim") | capitalize }}</b-dropdown-item
                  >
                </template>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="isEditClaimDoable(props.row.AdminClaim) == false"
                  @click="deleteOccurenceClaim(props.row.orderid, props.row.id)"
                  >{{ $translate("delete") | capitalize }}</b-dropdown-item
                >
              </b-dropdown>-->
            </template>

            <template v-else>
              <b-dropdown aria-role="list" position="is-bottom-left">
                <b-icon slot="trigger" class="has-text-primary" icon="menu-down" />
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="isEditDoable(props.row.statusOrder) == false"
                  @click="
                    $router.push({
                      name: 'editOrder',
                      params: { orderId: props.row.id, view: true, module: props.row.module },
                    })
                  "
                >
                  {{ $translate('edit') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  :disabled="isEditDoable(props.row.statusOrder) == false"
                  @click="deleteOccurence(props.row.id)"
                >
                  {{ $translate('delete') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  aria-role="listitem"
                  :disabled="
                    isClaimDoable(props.row.statusOrder) == false ||
                      props.row.haveclaimsCustomer == true ||
                      props.row.haveclaimsAdmin == true
                  "
                  @click="
                    $router.push({
                      name: 'newClaim',
                      params: { orderid: props.row.id, module: props.row.module },
                    })
                  "
                >
                  {{ $translate('claim') | capitalize }}
                </b-dropdown-item>
                <b-dropdown-item
                  class="pointercursor"
                  aria-role="listitem"
                  @click="
                    $router.push({
                      name: 'editOrder',
                      params: { orderId: props.row.id, view: false, module: props.row.module },
                    })
                  "
                >
                  {{ $translate('view') | capitalize }}
                </b-dropdown-item>

                <b-dropdown-item
                  :disabled="isHistoryViewable(props.row.company) == false || props.row.statusOrder === 'endord'"
                  class="pointercursor"
                  aria-role="listitem"
                  @click="viewHistory(props.row)"
                >
                  {{ $translate('history') | capitalize }}
                </b-dropdown-item>
              </b-dropdown>
            </template>
            <!--<PrintOrder
              :ref="'PrintOrder' + props.row.primaryCode"
              :order.sync="props.row"
            ></PrintOrder>-->
          </b-table-column>
        </template>
        <template slot="detail" slot-scope="props">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <template v-if="props.row.shop">
                    <strong>{{ $translate('shop') | capitalize }}:</strong>
                    <a
                      @click="
                        $router.push({
                          name: 'shops',
                          params: { shopId: props.row.shop.id },
                        })
                      "
                      >{{ props.row.shop.name }}</a
                    >
                    <br />
                  </template>
                  <strong>{{ $translate('primaryCode') | capitalize }}:</strong>
                  {{ props.row.primaryCode }}
                  <br />
                  <template v-if="props.row.shop">
                    <strong>{{ $translate('secondaryCode') | capitalize }}:</strong>
                    {{ props.row.secondaryCode }}
                    <br />
                  </template>
                  <strong>{{ $translate('technician') | capitalize }}:</strong>
                  {{ props.row.tec }}
                  <br />
                  <template v-if="props.row.claim">
                    <template v-if="props.row.answer">
                      <strong>{{ $translate('answer_date') | capitalize }}:</strong>
                      {{ new Date(props.row.answercreationDate).toLocaleDateString() }}
                      - {{ props.row.answertec }}
                      <br />
                    </template>
                    <template v-if="props.row.confirmed">
                      <strong>{{ $translate('check_date') | capitalize }}:</strong>
                      {{ new Date(props.row.DateCheck).toLocaleDateString() }}
                      -
                      {{ props.row.Checktec }}
                    </template>
                  </template>
                  <template v-else>
                    <strong>{{ $translate('orderTypeMain') | capitalize }}:</strong>
                    {{ $translate(props.row.orderTypeMain) }}
                    <template v-if="props.row.orderTypeVariant">
                      , {{ $translate(props.row.orderTypeVariant) }}
                    </template>
                    <template v-if="props.row.orderTypeSubVariant">
                      ,
                      {{ $translate(props.row.orderTypeSubVariant) }}
                    </template>
                    <br />
                    <strong>{{ $translate('deliverySelected') | capitalize }}:</strong>
                    {{ $translate(props.row.deliverySelected) }}
                    <template v-if="props.row.deliverySelectedSub">
                      ,
                      {{ $translate(props.row.deliverySelectedSub) }}
                    </template>
                    <br />
                    <strong>{{ $translate('track_numbe') | capitalize }}:</strong>
                    {{ $translate(props.row.track_number) }}
                    <br />
                    <strong>{{ $translate('expectedDeliveryDate') | capitalize }}:</strong>
                    {{
                      props.row.deliveryDate == undefined ? '-' : new Date(props.row.deliveryDate).toLocaleDateString()
                    }}
                    <template v-for="(claim, index) in props.row.claims">
                      <br :key="claim" />
                      <a
                        v-if="!props.row.claims[index].deleted && props.row.claims[index].status == 'confirmed'"
                        :key="claim"
                        :class="{
                          'has-text-danger': claim.inadequate,
                        }"
                        @click="
                          $router.push({
                            name: 'Claim',
                            params: { orderid: props.row.id, id: index, module: props.row.module },
                          })
                        "
                      >
                        {{ claim.primaryCode }}
                      </a>
                    </template>
                  </template>
                </p>
              </div>
            </div>
          </article>
        </template>
        <template v-if="!disableRequestMore" slot="footer">
          <b-button expanded @click="appendData()">
            <b-icon icon="arrow-down-thick" />
          </b-button>
        </template>
        <template slot="empty">
          <section v-if="!tableOptions.loading" class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <b-icon icon="emoticon-sad" size="is-large" />
              </p>
            </div>
          </section>
        </template>
      </b-table>
      <b-modal :active.sync="massivetrackingmodal" :width="640" scroll="keep">
        <div class="modal-card" style="width: auto">
          <header class="modal-card-head">
            <p class="modal-card-title">
              {{ $translate('track_numbe') | capitalize }}
            </p>
          </header>
          <section class="modal-card-body">
            <table class="table">
              <thead>
                <th>{{ $translate('primaryCode') | capitalize }}</th>
                <th>ex-{{ $translate('track_numbe') | capitalize }}</th>
                <th>{{ $translate('id_mercury') | capitalize }}</th>
                <th>{{ $translate('track_numbe') | capitalize }}</th>
              </thead>
              <tbody>
                <tr v-for="currentorder in massivecurrentorderid" :key="currentorder.id">
                  <td>{{ $translate(currentorder.primaryCode) }}</td>
                  <td>{{ $translate(currentorder.track_number) }}</td>
                  <td>{{ $translate(currentorder.mercurio_id) }}</td>
                  <td>
                    <b-input v-model="newtrack_number" :value="currentorder.track_number" maxlength="20" />
                  </td>
                </tr>
              </tbody>
            </table>
            <!--<b-field
              v-for="currentorder in massivecurrentorderid"
              :key="currentorder.id"
              horizontal
            >
              <template slot="label">
                {{ $translate(currentorder.primaryCode) }}<br />
                <template v-if="currentorder.track_number"
                  >ex {{ $translate("track_numbe") | capitalize }} :
                  {{ currentorder.track_number }}</template
                >
              </template>

              <b-input
                v-model="newtrack_number"
                :value="currentorder.track_number"
              ></b-input>
            </b-field>-->
          </section>
          <footer class="modal-card-foot">
            <button class="button" type="button" @click="massivetrackingmodal = false">
              Close
            </button>
            <button class="button is-primary" @click="massivechangeTrack()">
              {{ $translate('track_numbe') | capitalize }}
            </button>
          </footer>
        </div>
      </b-modal>
      <PrintOrder :print-order-bool.sync="printOrderBool" :orders.sync="printOrders" />
      <HistoryOrderModal :history-modal-bool.sync="historyModalBool" :history-order.sync="historyOrder" />
    </div>
  </section>
</template>

<script>
import mainMixin from '@/helpers/mixins/mainMixin'
import permissionMixin from '@/helpers/mixins/permissionMixin'
import orderTools from '@/helpers/mixins/orderTools'
import exportTools from '@/helpers/mixins/exportTools'
import firebase from 'firebase'
import filterSelect from '@/components/FilterSelect'
import PrintOrder from '@/views/Orders/components/PrintOrder'
import HistoryOrderModal from '@/views/Orders/components/HistoryOrderModal'

import JSZip from 'jszip'
import saveAs from 'file-saver'
//import request from "request";

export default {
  name: 'CustomerOrders',
  components: {
    'filter-select': filterSelect,
    PrintOrder: PrintOrder,
    HistoryOrderModal: HistoryOrderModal,
  },
  mixins: [mainMixin, permissionMixin, orderTools, exportTools],
  data() {
    return {
      isJSONViewableCustomer: true,
      massivetrackingmodal: false,
      massivecurrentorderid: [],
      newtrack_number: null,

      //AllshopsId: [],
      AllStatus: [],
      AlldeliverySelected: [],
      AllorderType: [],
      AllorderTypeMain: [],
      //indici sorting
      statusIndex: 0,
      companiesindex: 0,
      shopIndex: 0,
      deliveryindex: 0,
      orderTypeindex: 0,
      orderTypeMainindex: 0,

      mainQuery: this.$db.collection('orders'),
      limit: 20,
      disableRequestMore: true,
      lastRequested: null,
      startDate: null,
      enddate: null,
      statusSelected: this.$status['tailored'],
      editableStatus: ['compord', 'invord', 'deletedord'],
      queryString: '',
      isSwitched: 0,
      historyModalBool: false,
      historyOrder: null,
      printOrderBool: false,
      printOrders: null,
      field: 'statusOrder',
      order: 'asc',

      orderTypeFilterInfo: {
        label: 'orderType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      orderTypeMainFilterInfo: {
        label: 'orderTypeMain',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      deliverySelectedFilterInfo: {
        label: 'deliveryType',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      statusOrderFilterInfo: {
        label: 'status',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      moduleFilterInfo: {
        label: 'module',
        options: [{ name: '*' }],
        filterValue: '*',
      },
      availableStatus: [],
      patientFilter: undefined,
    }
  },
  mounted() {
    this.AllStatus = this.$status['tailored']
    switch (this.userInfo.type) {
      case 'A':
        this.$router.push('/forbidden')
        break
      case 'I':
        this.$router.push('/forbidden')
        break
      case 'C':
        //console.log(this.userInfo.level);
        if (this.userInfo.level == 1) {
          this.availableStatus = ['compord', 'invord', 'deletedord']
        } else {
          this.availableStatus = ['compord', 'invord', 'sendord', 'deletedord']
        }
        break
      default:
        this.$router.push('/forbidden')
        break
    }

    let filtersStatus = this.$store.state.filters.customerOrders
    if (this.$route.params.patientId) {
      this.setFilterValues(
        filtersStatus.type,
        filtersStatus.typeMain,
        filtersStatus.delivery,
        filtersStatus.status,
        this.$route.params.patientId,
        filtersStatus.text,
        filtersStatus.module
      )
    }

    this.loadData()
  },
  methods: {
    openCopyOrder(order) {
      if (order.company.bdictionary == 'B2' && order.statusOrder != 'compord' && order.module !== 'fits') {
        this.$router.push({
          name: 'simplifiedCopyOrder',
          params: {
            orderIdToCopy: order.id,
          },
        })
      } else {
        this.$router.push({
          name: 'copyOrder',
          params: {
            orderIdToCopy: order.id,
          },
        })
      }
    },
    evaluateRowClass(row) {
      if (row.claim) return 'is-claim'
      if (row.haveclaimsCustomer) return 'has-claim'
      if (row.statusOrder == 'sendord') return 'is-sendord'
      if (row.statusOrder == 'workord') return 'is-workord'
      if (row.statusOrder == 'standord') return 'is-standord'
      if (row.statusOrder == 'endord') return 'is-endord'
      if (row.statusOrder == 'waitord') return 'is-waitord'
      if (row.statusOrder == 'invord') return 'is-invord'
    },

    isClosed() {
      let order = 0
      this.tableOptions.checkedRows.forEach(row => {
        if (
          !row.claim &&
          (row.statusOrder == 'closed' || row.statusOrder == 'processed' || row.statusOrder == 'compord')
        ) {
          order += 1
        }
      })
      return order
    },

    openPrintModal() {
      this.printOrderBool = true
      this.printOrders = this.tableOptions.checkedRows
    },

    viewHistory(rowhistory) {
      this.historyOrder = rowhistory
      this.historyModalBool = true
      this.$forceUpdate()
    },

    sortPressed(field, order) {
      this.enddate = null
      this.startdate = null
      switch (field) {
        case 'statusOrder':
          this.AllStatus.reverse()
          break
        case 'deliverySelected':
          this.AlldeliverySelected.reverse()
          break
        case 'orderType':
          this.AllorderType.reverse()
          break
        case 'orderTypeMain':
          this.AllorderTypeMain.reverse()
          break
      }

      this.field = field
      this.order = order
      this.searchData()
    },
    async getAttachment() {
      //this.isSaveDisabled = true;
      const cloneDeep = require('clone-deep')
      this.tableOptions.loading = true
      var zip = new JSZip()
      for (let row in this.tableOptions.checkedRows) {
        for (var item in this.tableOptions.checkedRows[row].attachment) {
          if (this.tableOptions.checkedRows[row].attachment[item] != null) {
            if (this.tableOptions.checkedRows[row].attachment[item].name) {
              //
            } else {
              let oldmeta = ''
              const storageRef = this.$storage.ref(
                'order/attachment/' + this.tableOptions.checkedRows[row].id + '/' + item
              )

              await storageRef.getMetadata().then(metadata => {
                oldmeta = metadata.contentType
              })
              if (item.substring(item.length - 6, item.length - 3) == 'pln') {
                oldmeta = 'pln'
              } else if (item.substring(item.length - 6, item.length - 3) == 'fms') {
                oldmeta = 'fms'
              } else if (item.substring(item.length - 6, item.length - 3) == 'stl') {
                oldmeta = 'stl'
              } else if (item.substring(item.length - 6, item.length - 3) == 'una') {
                oldmeta = 'stl'
              } else {
                oldmeta = oldmeta.substr(oldmeta.length - 3)
                if (oldmeta == 'peg') {
                  oldmeta = 'jpeg'
                }
              }
              await storageRef.getDownloadURL().then(async url => {
                await fetch(url).then(async htmlReturn => {
                  let previousChunk = new Uint8Array()
                  let fileArray = new Uint8Array()
                  const reader = htmlReturn.body.getReader()
                  await reader
                    .read()
                    .then(function appendStreamChunk({ done, value }) {
                      if (value) {
                        previousChunk = cloneDeep(fileArray)
                        fileArray = new Uint8Array(previousChunk.length + value.length)
                        fileArray.set(previousChunk)
                        fileArray.set(value, previousChunk.length)
                      }
                      if (done) {
                        return fileArray
                      } else {
                        return reader.read().then(appendStreamChunk)
                      }
                    })
                    .then(async file => {
                      let dirname = ''
                      if (this.tableOptions.checkedRows[row].primaryCode) {
                        dirname = this.tableOptions.checkedRows[row].primaryCode
                      } else {
                        dirname = this.tableOptions.checkedRows[row].id
                      }
                      zip.file(dirname + '/' + item + '.' + oldmeta, file, {
                        createFolders: true,
                      })
                    })
                    .catch()
                })
              })
            }
          }
        }
      }
      zip.generateAsync({ type: 'blob' }).then(
        content => {
          saveAs(
            content,
            this.$store.getters.user.userInfo.name +
              this.$store.getters.user.userInfo.surname +
              new Date().toLocaleDateString() +
              '.zip'
          )
        } //,
        //function(err) {
        //console.log(err);
        //}
      )
      //this.isSaveDisabled = false;
      this.tableOptions.loading = false
    },
    checkIfSendablewithParameter(statusString) {
      if (statusString != 'compord' && statusString != 'deletedord') {
        let areSendable = true
        this.tableOptions.checkedRows.forEach(order => {
          //if (!this.isSendable(order)) {
          //  areSendable = false;
          //}
          if (!this.checkSend(order)) {
            areSendable = false
          }
        })
        if (!areSendable) {
          this.$buefy.dialog.alert({
            title: this.$options.filters.capitalize(this.$translate('error')),
            message: this.$options.filters.capitalize(this.$translate('changeStatusNotPermitted')),
            type: 'is-danger',
            hasIcon: true,
            icon: 'alert',
            ariaRole: 'alertdialog',
            ariaModal: true,
          })
        }
        return areSendable
      } else {
        return true
      }
    },

    groupChangeStatuswithPrameters(statusString) {
      if (this.hasSameStatus() && this.checkIfSendablewithParameter(statusString)) {
        {
          this.tableOptions.checkedRows.forEach(order => {
            this.$db
              .collection('orders')
              .doc(order.id)
              .update({ statusOrder: statusString })
              .then(() => {
                order.statusOrder = statusString
              })
          })
        }
      }
    },

    massivechangeTrack() {
      this.massivetrackingmodal = false
      for (let order in this.massivecurrentorderid) {
        this.$db
          .collection('orders')
          .doc(this.massivecurrentorderid[order].id)
          .update({
            track_number: this.newtrack_number,
          })
          .then(() => {
            this.massivecurrentorderid[order].track_number = this.newtrack_number
            this.$forceUpdate()
          })
      }
    },
    trackcodechangemodal() {
      this.massivecurrentorderid = []
      this.tableOptions.checkedRows.forEach(row => {
        if (!row.claim) {
          if (this.userInfo.type == 'C' && row.statusOrder == 'invord') {
            this.massivecurrentorderid.push(row)
          } else {
            if (
              this.userInfo.type == 'C' &&
              this.userInfo.level != 1 &&
              (row.statusOrder == 'invord' || row.statusOrder == 'waitord' || row.statusOrder == 'sendord')
            ) {
              this.massivecurrentorderid.push(row)
            } else {
              if (this.userInfo.type == 'I' && (row.statusOrder == 'courier' || row.statusOrder == 'closed')) {
                this.massivecurrentorderid.push(row)
              } else {
                if (this.userInfo.type == 'A') {
                  this.massivecurrentorderid.push(row)
                }
              }
            }
          }
        }
      })
      if (this.massivecurrentorderid.length > 0) {
        this.massivetrackingmodal = true
      }
    },

    hasAvailableStatus(orders) {
      let selectedStatus = orders[0].statusOrder
      if (this.editableStatus.find(status => status == selectedStatus)) return true
      return false
    },
    //hasSameStatus(orders) {
    //  let actualStatus = orders[0].statusOrder;
    //  if (orders.filter(ord => ord.statusOrder != actualStatus).length != 0)
    //    return false;
    //  return true;
    //},
    hasSameStatus(status = undefined) {
      if (this.tableOptions.checkedRows.length == 0) return false
      if (!status) {
        status = this.tableOptions.checkedRows[0].statusOrder
      }
      let isStatusDifferent = false
      this.tableOptions.checkedRows.forEach(order => {
        if (!order.claim && order.statusOrder != status) {
          isStatusDifferent = true
        }
      })
      return !isStatusDifferent
    },
    isMassiveChangeDisabled() {
      if (
        this.tableOptions.checkedRows.length != 0 &&
        this.hasSameStatus() &&
        this.hasAvailableStatus(this.tableOptions.checkedRows)
      ) {
        return false
      }
      return true
    },
    isTrackingNumberDisabled() {
      if (this.userInfo.level == 1) {
        if (this.hasSameStatus('invord')) {
          return false
        }
        return true
      } else {
        if (this.hasSameStatus('invord') || this.hasSameStatus('sendord') || this.hasSameStatus('waitord')) {
          return false
        }
        return true
      }
    },
    checkIfSendable() {
      if (this.statusSelected == 'invord' || this.statusSelected == 'sendord') {
        let areSendable = true
        this.tableOptions.checkedRows.forEach(order => {
          //if (!this.isSendable(order)) {
          //areSendable = false
          //}
          if (!this.checkSend(order)) {
            areSendable = false
          }
        })
        if (!areSendable) {
          this.$buefy.dialog.alert({
            title: this.$options.filters.capitalize(this.$translate('error')),
            message: this.$options.filters.capitalize(this.$translate('changeStatusNotPermitted')),
            type: 'is-danger',
            hasIcon: true,
            icon: 'alert',
            ariaRole: 'alertdialog',
            ariaModal: true,
          })
        }
        return areSendable
      } else {
        return true
      }
    },
    applyStatus() {
      //creo un update batch che contiene gli ordini aggiornati
      var batch = this.$db.batch()
      this.oldOrders.forEach(order => {
        var orderref = this.$db.collection('orders').doc(order.id)
        batch.update(orderref, order)
      })
      //eseguo la chiamata batch
      batch
        .commit()
        .then(() => {
          //Aggiorno la tabella
          this.tableOptions.checkedRows.forEach(order => {
            order.statusOrder = this.oldOrders[0].statusOrder
          })
          switch (this.isSwitched) {
            case 1:
              if (!this.$statusClosed.includes(this.oldOrders[0].statusOrder)) {
                this.tableOptions.checkedRows.forEach(row => {
                  this.tableData.splice(this.tableData.indexOf(row), 1)
                })
              }
              break
            case 2:
              if (this.oldOrders[0].statusOrder != 'deletedord') {
                this.tableOptions.checkedRows.forEach(row => {
                  this.tableData.splice(this.tableData.indexOf(row), 1)
                })
              }
              break
            default:
              if (!this.$statusActive.includes(this.oldOrders[0].statusOrder)) {
                this.tableOptions.checkedRows.forEach(row => {
                  this.tableData.splice(this.tableData.indexOf(row), 1)
                })
              }
              break
          }

          //se va a buon fine avverto e tolgo le spunte
          this.tableOptions.checkedRows = []
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('success_form'),
            type: 'is-success',
          })
        })
        .catch(() => {
          //se non dovesse andare a buon fine faccio il revert con i vecchi ordini
          this.$buefy.notification.open({
            duration: 3000,
            message: this.$translate('failed_form'),
            type: 'is-danger',
          })
        })
    },
    changeStatus(newStatus = this.statusSelected) {
      if (newStatus === 'invord' || newStatus === 'sendord') {
        const failedOrders = this.tableOptions.checkedRows.filter(order => !this.checkSend(order))
        if (failedOrders.length) {
          this.$buefy.dialog.alert({
            title: this.$options.filters.capitalize(this.$translate('error')),
            message:
              this.$options.filters.capitalize(this.$translate('orders_check_failed')) +
              '<br><strong>' +
              failedOrders.map(order => order.primaryCode || order.id).join(', ') +
              '</strong>',
            type: 'is-danger',
            hasIcon: true,
            icon: 'alert',
            ariaRole: 'alertdialog',
            ariaModal: true,
          })
          return
        }
      }
      //Se l'aggiornamento batch dovesse non andare a buon fine devo fare il revert degli ordini
      const cloneDeep = require('clone-deep')
      this.oldOrders = cloneDeep(this.tableOptions.checkedRows)
      //Se posso aggiornare lo stato lo faccio
      //Altrimenti avverto che non è stato possibile cambiare stato
      if (this.changeGroupStatus(this.oldOrders, newStatus)) {
        //Controllo se sono C1 e il newStatus è inviabile, devo usare un alert
        if (this.userInfo.type == 'C' && this.userInfo.level == '1' && newStatus == 'invord') {
          this.$buefy.dialog.confirm({
            title: this.$translate('attention'),
            message: this.$translate('confirm_sendord_C'),
            cancelText: this.$translate('undo'),
            confirmText: this.$translate('confirm'),
            type: 'is-danger',
            hasIcon: true,
            onConfirm: () => {
              this.applyStatus()
            },
          })
        } else {
          this.applyStatus()
        }
      } else {
        this.$buefy.dialog.alert({
          title: this.$options.filters.capitalize(this.$translate('error')),
          message: this.$options.filters.capitalize(this.$translate('changeStatusNotPermitted')),
          type: 'is-danger',
          hasIcon: true,
          icon: 'alert',
          ariaRole: 'alertdialog',
          ariaModal: true,
        })
      }
    },
    groupChangeStatus() {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('claim_orders_changeStatus'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('confirm'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          if (this.hasSameStatus() && this.checkIfSendable()) {
            var batch = this.$db.batch()
            let newStatus = {}
            let newsend_date = {}
            let deletedarray = {}

            this.tableOptions.checkedRows.forEach(order => {
              newsend_date[order] = order.send_date

              if (this.statusSelected != 'compord' && this.statusSelected != 'invord' && order.send_date == null) {
                newsend_date[order] = new Date().getTime()
              }
              newStatus[order] = this.statusSelected

              if (order.statusOrder == 'sendord' && this.statusSelected == 'proc_order') {
                if (this.isWaitForMaterialsOrder()) {
                  newStatus[order] = 'waitord'
                }
              }
              if (newStatus[order] == 'deletedord') {
                deletedarray[order] = true
              } else {
                deletedarray[order] = false
              }

              //! deve diventare operazione batch?SI
              /*this.$db
                .collection("orders")
                .doc(order.id)
                .update({ statusOrder: newStatus })
                .then(() => {
                  order.statusOrder = newStatus;
                });*/

              //carico il batch con lo status
              var orderref = this.$db.collection('orders').doc(order.id)
              batch.update(orderref, {
                statusOrder: newStatus[order],
                send_date: newsend_date[order],
                deleted: deletedarray[order],
                lastModificationDate: new Date().getTime(),
                history: firebase.firestore.FieldValue.arrayUnion({
                  technician: this.$store.getters.user.userInfo.username,
                  date: new Date().getTime(),
                  oldStatus: order.statusOrder,
                  newStatus: newStatus[order],
                }),
              })
            })

            batch
              .commit()
              .then(() => {
                this.tableOptions.checkedRows.forEach(order => {
                  order.statusOrder = newStatus[order]
                  order.send_date = newsend_date[order]
                })
                this.tableOptions.checkedRows = []
                this.$buefy.notification.open({
                  duration: 3000,
                  message: this.$translate('success_form'),
                  type: 'is-success',
                })
              })
              .catch(() => {
                //console.log(error);
                this.$buefy.notification.open({
                  duration: 3000,
                  message: this.$translate('failed_form'),
                  type: 'is-danger',
                })
              })
          }
        },
      })
    },
    searchData() {
      this.tableData = []
      this.tableOptions.loading = true
      this.tableOptions.checkedRows = []

      //update filters
      this.setFilterValues(
        this.orderTypeFilterInfo.filterValue,
        this.orderTypeMainFilterInfo.filterValue,
        this.deliverySelectedFilterInfo.filterValue,
        this.statusOrderFilterInfo.filterValue,
        this.$store.state.filters.internalOrders.patient,
        this.queryString,
        this.moduleFilterInfo.filterValue
      )

      this.mainQuery = this.$db.collection('orders').where('company.id', '==', this.companiesId[0])

      if (this.patientFilter) {
        this.mainQuery = this.mainQuery.where(
          'patientId',
          '==',
          this.patientFilter
          //this.$route.params.patientId
        )
      }

      this.mainQuery = this.mainQuery.where('searchArray', 'array-contains', this.queryString.toLowerCase())
      if (this.startDate) {
        this.mainQuery = this.mainQuery.where('send_date', '>=', this.startDate.getTime())
      }
      if (this.enddate) {
        this.mainQuery = this.mainQuery.where('send_date', '<=', this.enddate.getTime() + 1000 * 60 * 60 * 24)
      }
      if (this.orderTypeFilterInfo.filterValue != '*') {
        if (this.orderTypeFilterInfo.filterValue == 'claim') {
          this.mainQuery = this.mainQuery.where('haveclaimsCustomer', '==', true)
        } else {
          this.mainQuery = this.mainQuery.where('orderType', '==', this.orderTypeFilterInfo.filterValue)
        }
      }
      if (this.orderTypeMainFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where('orderTypeMain', '==', this.orderTypeMainFilterInfo.filterValue)
      }
      if (this.deliverySelectedFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where('deliverySelected', '==', this.deliverySelectedFilterInfo.filterValue)
      }
      if (this.statusOrderFilterInfo.filterValue != '*') {
        this.mainQuery = this.mainQuery.where('statusOrder', '==', this.statusOrderFilterInfo.filterValue)
      }
      if (this.moduleFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('module', '==', this.moduleFilterInfo.filterValue)
      }

      this.lastRequested = null
      this.shopIndex = 0
      this.statusIndex = 0
      this.companiesindex = 0
      this.deliveryindex = 0
      this.orderTypeindex = 0
      this.orderTypeMainindex = 0

      this.appendData()
    },
    createFilters() {
      this.orderTypeFilterInfo.options = [{ name: '*' }]
      this.orderTypeMainFilterInfo.options = [{ name: '*' }]
      this.deliverySelectedFilterInfo.options = [{ name: '*' }]
      this.statusOrderFilterInfo.options = [{ name: '*' }]
      this.orderTypeFilterInfo.options.push({ name: 'claim' })
      for (let m of this.$modules) {
        if (!this.moduleFilterInfo.options.find(o => o.name === m)) {
          this.moduleFilterInfo.options.push({ name: m })
        }
      }

      this.AllorderType.push(null)
      this.AllorderTypeMain.push(null)
      this.AlldeliverySelected.push(null)

      for (let module of this.$modules) {
        this.$availableOrderType[module].forEach(dictionary => {
          dictionary.variant.forEach(element => {
            if (
              this.orderTypeFilterInfo.options
                .map(e => {
                  return e.name
                })
                .indexOf(element.key) === -1
            ) {
              this.orderTypeFilterInfo.options.push({ name: element.key })
              this.AllorderType.push(element.key)
            }
          })
        })

        this.$availableOrderType[module].forEach(dictionary => {
          if (dictionary.variant) {
            dictionary.variant.forEach(element => {
              if (element.variant) {
                element.variant.forEach(element2 => {
                  if (
                    this.orderTypeMainFilterInfo.options
                      .map(e => {
                        return e.name
                      })
                      .indexOf(element2.key) === -1
                  ) {
                    this.orderTypeMainFilterInfo.options.push({ name: element2.key })
                    this.AllorderTypeMain.push(element2.key)
                  }
                })
              }
            })
          }
        })

        this.$availableDeliveryType[module].forEach(dictionary => {
          dictionary.variant.forEach(element => {
            if (
              this.deliverySelectedFilterInfo.options
                .map(e => {
                  return e.name
                })
                .indexOf(element.key) === -1
            ) {
              this.deliverySelectedFilterInfo.options.push({ name: element.key })
              this.AlldeliverySelected.push(element.key)
            }
          })
        })
      }
      // this.$availableOrderType[this.module].forEach(dictionary => {
      //   dictionary.variant.forEach(element => {
      //     if (
      //       this.orderTypeFilterInfo.options
      //         .map(e => {
      //           return e.name
      //         })
      //         .indexOf(element.key) == -1
      //     ) {
      //       this.orderTypeFilterInfo.options.push({ name: element.key })
      //       this.AllorderType.push(element.key)
      //     }
      //   })
      // })
      //
      // this.$availableOrderType[this.module].forEach(dictionary => {
      //   dictionary.variant.forEach(element => {
      //     element.variant.forEach(element2 => {
      //       if (
      //         this.orderTypeMainFilterInfo.options
      //           .map(e => {
      //             return e.name
      //           })
      //           .indexOf(element2.key) == -1
      //       ) {
      //         this.orderTypeMainFilterInfo.options.push({ name: element2.key })
      //         this.AllorderTypeMain.push(element2.key)
      //       }
      //     })
      //   })
      // })
      //
      // this.$availableDeliveryType[this.module].forEach(dictionary => {
      //   dictionary.variant.forEach(element => {
      //     if (
      //       this.deliverySelectedFilterInfo.options
      //         .map(e => {
      //           return e.name
      //         })
      //         .indexOf(element.key) == -1
      //     ) {
      //       this.deliverySelectedFilterInfo.options.push({ name: element.key })
      //       this.AlldeliverySelected.push(element.key)
      //     }
      //   })
      // })

      this.$status['tailored'].forEach(element => {
        if (
          this.statusOrderFilterInfo.options
            .map(e => {
              return e.name
            })
            .indexOf(element) == -1 &&
          element != 'deletedord'
        ) {
          this.statusOrderFilterInfo.options.push({ name: element })
        }
      })
    },
    loadFilterValues() {
      this.orderTypeFilterInfo.filterValue = this.$store.state.filters.customerOrders.type
      this.orderTypeMainFilterInfo.filterValue = this.$store.state.filters.customerOrders.typeMain
      this.deliverySelectedFilterInfo.filterValue = this.$store.state.filters.customerOrders.delivery
      this.statusOrderFilterInfo.filterValue = this.$store.state.filters.customerOrders.status
      this.patientFilter = this.$store.state.filters.customerOrders.patient
      this.queryString = this.$store.state.filters.customerOrders.text
    },
    setFilterValues(type, typeMain, delivery, status, patient, text, module) {
      this.$store.commit('setFiltersCustomerOrders', {
        type: type,
        typeMain: typeMain,
        delivery: delivery,
        status: status,
        patient: patient,
        text: text,
        module: module,
      })
    },
    async loadData() {
      this.tableData = []
      await this.createFilters()

      //set latest filter used
      this.loadFilterValues()

      this.mainQuery = this.$db.collection('orders').where('company.id', '==', this.companiesId[0])

      //if (this.$route.params.patientId) {
      if (this.patientFilter) {
        this.mainQuery = this.mainQuery.where(
          'patientId',
          '==',
          this.patientFilter
          //this.$route.params.patientId
        )
      }

      if (this.queryString) {
        this.mainQuery = this.mainQuery.where('searchArray', 'array-contains', this.queryString.toLowerCase())
      }

      if (this.orderTypeFilterInfo.filterValue !== '*') {
        if (this.orderTypeFilterInfo.filterValue === 'claim') {
          this.mainQuery = this.mainQuery.where('haveclaimsCustomer', '==', true)
        } else {
          this.mainQuery = this.mainQuery.where('orderType', '==', this.orderTypeFilterInfo.filterValue)
        }
      }
      if (this.orderTypeMainFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('orderTypeMain', '==', this.orderTypeMainFilterInfo.filterValue)
      }
      if (this.deliverySelectedFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('deliverySelected', '==', this.deliverySelectedFilterInfo.filterValue)
      }
      if (this.statusOrderFilterInfo.filterValue !== '*') {
        this.mainQuery = this.mainQuery.where('statusOrder', '==', this.statusOrderFilterInfo.filterValue)
      }

      this.appendData()
    },
    appendData(newLimit = this.limit) {
      this.tableOptions.loading = true
      let thisQuery = this.mainQuery

      switch (this.isSwitched) {
        case 0:
          thisQuery = thisQuery.where('deleted', '==', false)

          thisQuery = thisQuery.where('statusOrder', 'in', this.$statusActive)
          break
        case 1:
          thisQuery = thisQuery.where('deleted', '==', false)
          thisQuery = thisQuery.where('statusOrder', 'in', this.$statusClosed)
          break
        case 2:
          thisQuery = thisQuery.where('deleted', '==', true)
          break
        default:
          thisQuery = thisQuery.where('deleted', '==', false)
          thisQuery = thisQuery.where('statusOrder', 'in', [
            'compord',
            'invord',
            'sendord',
            'proc_order',
            'workord',
            'waitord',
            'standord',
            'endord',
            'courier',
          ])
          break
      }

      if (this.field == 'statusOrder') {
        thisQuery = thisQuery.where('statusOrder', '==', this.AllStatus[this.statusIndex])
      }

      if (this.field == 'deliverySelected') {
        thisQuery = thisQuery.where('deliverySelected', '==', this.AlldeliverySelected[this.deliveryindex])
      }

      if (this.field == 'orderType') {
        thisQuery = thisQuery.where('orderType', '==', this.AllorderType[this.orderTypeindex])
      }

      if (this.field == 'orderTypeMain') {
        thisQuery = thisQuery.where('orderTypeMain', '==', this.AllorderTypeMain[this.orderTypeMainindex])
      }

      // console.log(this.field);
      // console.log(this.order);

      if (this.field == 'send_date') {
        thisQuery = thisQuery.orderBy(this.field, this.order)
      } else {
        thisQuery = thisQuery.orderBy('send_date', 'asc')
      }

      if (!this.allShops) {
        thisQuery = thisQuery.where('shop.id', '==', this.shopsId[this.shopIndex])
      }

      if (this.lastRequested != null) {
        thisQuery = thisQuery.startAt(this.lastRequested)
      }

      thisQuery
        .limit(newLimit + 1)
        .get()
        .then(docs => {
          if (docs.size > newLimit) {
            this.disableRequestMore = false
          } else {
            this.disableRequestMore = true
          }
          let i = 0
          docs.forEach(doc => {
            // console.log(doc)
            let order = doc.data()
            order.id = doc.id
            order.module = order.module || 'tailored'
            i++
            if (i <= newLimit) {
              this.tableData.push(order)
              this.isJSONViewableCustomer = !order.company.exportJSON
              for (let claim in order.claims) {
                order.claims[claim].primaryCode =
                  order.primaryCode + '_CLAIM_' + ('0000' + (parseInt(claim) + 1)).substr(-4, 4)
                if (order.claims[claim].answer) {
                  order.claims[claim].primaryCode = 'R_' + order.claims[claim].primaryCode
                }
                if (!order.claims[claim].deleted && order.claims[claim].status != 'confirmed') {
                  if (
                    (order.claims[claim].AdminClaim && order.claims[claim].status != 'saved') ||
                    !order.claims[claim].AdminClaim
                  ) {
                    order.claims[claim].id = claim
                    order.claims[claim].orderid = order.id
                    order.claims[claim].orderType = 'CLAIM'
                    order.claims[claim].claim = true
                    order.claims[claim].send_date = order.claims[claim].creationDate

                    this.tableData.push(order.claims[claim])
                  }
                }
              }
            }
            this.lastRequested = doc
          })

          if (
            this.disableRequestMore &&
            (this.shopsId.length > this.shopIndex + 1 || this.companiesId.length > this.companiesindex + 1)
          ) {
            this.shopIndex += 1
            this.companiesindex += 1
            this.lastRequested = null
            this.appendData(newLimit - docs.size)
          } else {
            if (
              this.disableRequestMore &&
              this.field == 'statusOrder' &&
              this.AllStatus.length > this.statusIndex + 1
            ) {
              this.shopIndex = 0
              this.companiesindex = 0
              this.statusIndex += 1

              this.lastRequested = null
              this.appendData(newLimit - docs.size)
            } else {
              if (
                this.disableRequestMore &&
                this.field == 'deliverySelected' &&
                this.AlldeliverySelected.length > this.deliveryindex + 1
              ) {
                this.shopIndex = 0
                this.companiesindex = 0
                this.deliveryindex += 1

                this.lastRequested = null
                this.appendData(newLimit - docs.size)
              } else {
                if (
                  this.disableRequestMore &&
                  this.field == 'orderTypeMain' &&
                  this.AllorderTypeMain.length > this.orderTypeMainindex + 1
                ) {
                  this.shopIndex = 0
                  this.companiesindex = 0
                  this.orderTypeMainindex += 1

                  this.lastRequested = null
                  this.appendData(newLimit - docs.size)
                } else {
                  if (
                    this.disableRequestMore &&
                    this.field == 'orderType' &&
                    this.AllorderType.length > this.orderTypeindex + 1
                  ) {
                    this.shopIndex = 0
                    this.companiesindex = 0
                    this.orderTypeindex += 1

                    this.lastRequested = null
                    this.appendData(newLimit - docs.size)
                  } else {
                    this.tableOptions.loading = false
                  }
                }
              }
            }
          }
        })
    },
    deleteOccurenceClaim(orderid, idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('claim_message_confirm'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('claim_message_destroy'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection('orders')
            .doc(orderid)
            .get()
            .then(doc => {
              let order = doc.data()
              order.claims[idtoerase].deleted = true
              order.haveclaimsAdmin = false
              order.haveclaimsCustomer = false
              for (let index in order.claims) {
                if (!order.claims[index].deleted && !order.claims[index].confirmed) {
                  if (order.claims[index].status != 'saved') {
                    order.haveclaimsAdmin = true
                    order.haveclaimsCustomer = true
                  } else {
                    if (this.claim.AdminClaim) {
                      order.haveclaimsAdmin = true
                    } else {
                      order.haveclaimsCustomer = true
                    }
                  }
                }
              }

              this.$db
                .collection('orders')
                .doc(orderid)
                .update({
                  statusOrder: order.claims[idtoerase].originalStatus,
                  claims: order.claims,
                  haveclaimsCustomer: order.haveclaimsCustomer,
                  haveclaimsAdmin: order.haveclaimsAdmin,
                })
                .then(() => {
                  this.searchData()
                  this.$buefy.notification.open({
                    duration: 3000,
                    message: this.$translate('success_delete'),
                  })
                })
            }),
      })
    },

    deleteOccurence(idtoerase) {
      this.$buefy.dialog.confirm({
        title: this.$translate('attention'),
        message: this.$translate('order_message_confirm'),
        cancelText: this.$translate('undo'),
        confirmText: this.$translate('order_message_destroy'),
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () =>
          this.$db
            .collection('orders')
            .doc(idtoerase)
            .set(
              {
                statusOrder: 'deletedord',
                deleted: true,
              },
              { merge: true }
            )
            .then(() => {
              this.searchData()
              this.$buefy.notification.open({
                duration: 3000,
                message: this.$translate('success_delete'),
              })
            }),
      })
    },
    async exportJsonArray() {
      await this.exportOrdersJson(this.tableOptions.checkedRows)
    },
    async sendJsonArrayToMercurio() {
      this.tableOptions.loading = true
      await this.sendOrdersToMercurio(this.tableOptions.checkedRows)
      this.tableOptions.loading = false
    },
    /*exportPdfTable() {
      let data = [];
      this.tableOptions.checkedRows.forEach(row => {
        let newRow = {};
        newRow[this.$translate("order_id")] = row.id;
        newRow[this.$translate("client_code")] = row.company.mercurio_id;
        newRow[this.$options.filters.capitalize(this.$translate("customer"))] =
          row.company.name;
        newRow[this.$translate("date")] = new Date(row.send_date).toLocaleDateString();
        newRow[this.$translate("orderType")] = this.$translate(row.orderType);
        newRow[this.$translate("orderTypetext")] = this.$translate(row.orderTypeMain);
        newRow[this.$translate("orderTypeVariant")] = this.$translate(row.orderTypeVariant);
        newRow[this.$options.filters.capitalize(this.$translate("patient"))] = row
          .patient.alias
          ? row.patient.alias
          : row.patient.name + " " + row.patient.surname;
        newRow[this.$translate("primaryCode")] = row.primaryCode ? row.primaryCode : "";
        newRow[this.$translate("secondaryCode")] = row.secondaryCode
          ? row.secondaryCode
          : "";
        newRow[this.$translate("prec_pair")] = row.prec_pair ? row.prec_pair : "";
        newRow[this.$translate("track_numbe")] = "";
        newRow[this.$options.filters.capitalize(this.$translate("id_mercury"))] = "";
        data.push(Object.assign({}, newRow));
      });

      let keys = [
        { name: this.$translate("order_id"), width: 90 },
        { name: this.$translate("client_code"), width: 40 },
        {
          name: this.$options.filters.capitalize(this.$translate("customer")),
          width: 100
        },
        { name: this.$translate("date"), width: 40 },
        { name: this.$translate("orderType"), width: 55 },
        { name: this.$translate("orderTypetext"), width: 70 },
        { name: this.$translate("orderTypeVariant"), width: 75 },
        {
          name: this.$options.filters.capitalize(this.$translate("patient")),
          width: 70
        },
        { name: this.$translate("primaryCode"), width: 90 },
        { name: this.$translate("secondaryCode"), width: 90 },
        { name: this.$translate("prec_pair"), width: 40 },
        { name: this.$translate("track_numbe"), width: 40 },
        {
          name: this.$options.filters.capitalize(this.$translate("id_mercury")),
          width: 40
        }
      ];

      var headers = [];
      for (var i = 0; i < keys.length; i += 1) {
        headers.push({
          id: keys[i].name,
          name: keys[i].name,
          prompt: keys[i].name,
          align: "center",
          width: keys[i].width,
          padding: 0
        });
      }

      var doc = new jsPDF("l", "px", "a4");
      doc.table(1, 1, data, headers, { padding: 0, fontSize: 6 });

      doc.save(
        `Lista${this.$store.getters.user.userInfo.name}${
          this.$store.getters.user.userInfo.surname
        }${new Date().toLocaleDateString()}.pdf`
      );
    }*/
  },
}
</script>
<style scoped>
.container >>> .table-footer td {
  color: #bdbdbd;
}

@media only screen and (min-width: 1280px) {
  .container >>> .b-table .table th {
    font-weight: 600;
    position: sticky;
    top: 120px;
    background: white;
    z-index: 8;
  }

  .first-level {
    height: 60px;
    background: white;
    top: 0px;
    position: sticky;
    z-index: 9;
    margin-top: 0;
    margin-bottom: 0;
  }

  .second-level {
    height: 60px;
    background: white;
    top: 60px;
    position: sticky;
    z-index: 8;
    margin-top: 0;
    margin-bottom: 0;
  }

  .container >>> .dropdown-menu {
    z-index: 5;
  }
}
</style>
